export const CoursePdfsScreenPath = "/course-pdfs";
